import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/favicon.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon"
}, null, -1)
const _hoisted_3 = { class: "fw-bold ms-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseOne",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseOne"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard")
], -1)
const _hoisted_11 = {
  id: "sidebarCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_14 = { class: "sidebar-sub-menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.config.empresa), 1)
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vendas ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}